const FS_COUNTRY_PHONE_SELECTOR = '.fs-country-phone';
const freshworksSheet = new CSSStyleSheet();
freshworksSheet.replaceSync(`
  .fserv-input-text,
  .iti__selected-country {
    display: flex;
    align-items: center;
    gap: 0;
    height: 60px;
    padding: var(--Spacing-padding-2x) !important;
    border: var(--Border-border) solid var(--Pattern-Input-input-borderColour) !important;
    border-radius: var(--Corner-corner-xsmall);
    background: var(--Pattern-Input-input-bgColour-surface);
    font-family: $fontFamily-main !important;
    font-weight: 400;
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
    align-self: stretch;
    width: 100%;
    box-sizing: border-box;

    &:hover,
    &:focus {
      border-color:var(--Pattern-Input-input-borderColour-hover) !important;
    }

    &:focus-visible {
      border-color: var(--Foundational-Border-borderColour-hover);
      border-radius: 0;
      outline: var(--Border-border-focus) solid var(--Foundational-Border-borderColour-focused);
    }

    &::placeholder {
      color: var(--Pattern-Input-input-text-placeholder) !important;
      font-family: 'DM Sans', -apple-system, blinkmacsystemfont, 'Segoe UI', sans-serif !important;
    }
  }

  .iti__arrow {
    content: '';
    position: static;
    z-index: z-index('base');
    width: var(--Icon-icon-medium);
    height: var(--Icon-icon-medium);
    border: none;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgOUwxMiAxNUwxOCA5IiBzdHJva2U9IiMxRDMwMjgiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=");
  }
`);

function applyFreshworksStylesToElement(el: Element) {
  const htmlEl = el as HTMLElement & { shadowRoot?: ShadowRoot };
  if (htmlEl.shadowRoot && !htmlEl.shadowRoot.adoptedStyleSheets.includes(freshworksSheet)) {
    htmlEl.shadowRoot.adoptedStyleSheets = [...htmlEl.shadowRoot.adoptedStyleSheets, freshworksSheet];
  }
}

function injectFreshworksStyles() {
  const elements = document.querySelectorAll(FS_COUNTRY_PHONE_SELECTOR);
  elements.forEach(applyFreshworksStylesToElement);
}

// Initial run in case elements are already present
injectFreshworksStyles();

// Observe for dynamically added elements
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) {
        const element = node as Element;
        if (element.classList && element.classList.contains(FS_COUNTRY_PHONE_SELECTOR.slice(1))) {
          applyFreshworksStylesToElement(element);
        }
        if (typeof element.querySelectorAll === 'function') {
          element.querySelectorAll(FS_COUNTRY_PHONE_SELECTOR).forEach(applyFreshworksStylesToElement);
        }
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });
